import { UserDataService } from 'src/app/data/repository/user-repository/user-data.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GenericResponse } from '../generic-response';
import {
  HatedFoodModel,
  HatedFoodsModel,
} from 'src/app/core/model/hated-food-model';
import { baseUrl } from 'src/app/global-variables';

@Injectable({
  providedIn: 'root',
})
export class HatedFoodService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService
  ) {}

  getHatedFoodsServer(): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<HatedFoodModel[]>(baseUrl + 'api/v2/food/hatedFood', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((res) => {
        if (res) {
          this.saveHatedFoods(res);
          response = new GenericResponse(true);
        } else {
          response = new GenericResponse(false);
        }
        return response;
      })
      .catch((e) => {
        response = new GenericResponse(false);
        return response;
      });
  }

  prepare(res: HatedFoodModel[]): HatedFoodsModel {
    return new HatedFoodsModel(res);
  }

  saveHatedFoods(res: HatedFoodModel[]) {
    localStorage.setItem('hatedfoods', JSON.stringify(this.prepare(res)));
  }

  getHatedFoods(): Promise<HatedFoodsModel> {
    const hJson = localStorage.getItem('hatedfoods');
    const hatedfoods = HatedFoodsModel.fromJSON(hJson);
    if (hatedfoods) {
      return Promise.resolve(hatedfoods);
    }
  }

  getHatedFoodsIds(names: string[]) {
    let ids = [];
    const hJson = localStorage.getItem('hatedfoods');
    const hatedfoods = HatedFoodsModel.fromJSON(hJson);
    if (hatedfoods) {
      hatedfoods.hatedfoods.forEach((hatedfood) => {
        if (names.includes(hatedfood.name)) {
          ids.push(hatedfood.id);
        }
      });
      return ids;
    }
  }

  getHatedFoodNamesByIds(ids: string[]): Promise<string[]> {
    let names: string[] = [];
    if (localStorage.getItem('hatedfoods')) {
      const hJson = localStorage.getItem('hatedfoods');
      const hatedfoods = HatedFoodsModel.fromJSON(hJson);
      if (hatedfoods) {
        hatedfoods.hatedfoods.forEach((hatedfood) => {
          if (ids.includes(hatedfood.id)) {
            names.push(hatedfood.name);
          }
        });
        return Promise.resolve(names);
      }
    } else {
      return this.getHatedFoodsServer().then((res) => {
        if (res.isSuccess()) {
          const hJson = localStorage.getItem('hatedfoods');
          const hatedfoods = HatedFoodsModel.fromJSON(hJson);
          if (hatedfoods) {
            hatedfoods.hatedfoods.forEach((hatedfood) => {
              if (ids.includes(hatedfood.id)) {
                names.push(hatedfood.name);
              }
            });
            return Promise.resolve(names);
          }
        }
      });
    }
  }
}
